/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

// Mirror image of normalizeTextLeaves: a blueprint path with no ".__text"
// suffix expects a plain value, but if that leaf happens to carry an
// attribute (eg a redundant xmlns Chrome's parser didn't strip), x2js still
// wraps it as {__text, $attr...} and the blueprint hands back the wrapper
// object instead of the value. Walk the transformed result and collapse any
// such leftover wrapper down to its .__text value, wherever it appears.
module.exports = function collapseTextLeaves(value) {
  if ($.isArray(value)) {
    value.forEach(collapseTextLeaves);
  } else if ($.isPlainObject(value)) {
    $.each(value, function(key, child) {
      if ($.isPlainObject(child) && typeof child.__text !== 'undefined') {
        value[key] = child.__text;
      } else {
        collapseTextLeaves(child);
      }
    });
  }
};
